import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, useSyncExternalStore, type ReactNode } from 'react';
import { makeTrpcClient, trpc } from './api';
import { getSession, onSession } from './session';

export function ApiProvider({ children }: { children: ReactNode }) {
  const [qc] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
      }),
  );
  const [client] = useState(makeTrpcClient);
  return (
    <trpc.Provider client={client} queryClient={qc}>
      <QueryClientProvider client={qc}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}

export const useSession = () => useSyncExternalStore(onSession, getSession);
